/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Pale_Hen_StirInputs */

const en_neat_pale_hen_stir = /** @type {(inputs: Neat_Pale_Hen_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments allowed`)
};

const de_neat_pale_hen_stir = /** @type {(inputs: Neat_Pale_Hen_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare freigegeben`)
};

/**
* | output |
* | --- |
* | "Comments allowed" |
*
* @param {Neat_Pale_Hen_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_pale_hen_stir = /** @type {((inputs?: Neat_Pale_Hen_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Pale_Hen_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_pale_hen_stir(inputs)
	return de_neat_pale_hen_stir(inputs)
});